import { useCallback, useState } from 'react';
import { get, set } from '../../../../store/safeLocalStorage';

const STORAGE_KEY = 'm24NavRail';

/**
 * Design navigation-v2 1f: from 1200 px up the collapsed rail is the viewer's choice, kept in this
 * browser. Between 769 and 1199 px the rail is the only layout, whatever this says; the CSS
 * decides that.
 */
export function useSidebarRail(): { isRail: boolean; toggleRail: () => void } {
  const [isRail, setIsRail] = useState<boolean>(() => get<boolean>(STORAGE_KEY) === true);

  const toggleRail = useCallback(() => {
    setIsRail((current) => {
      set(STORAGE_KEY, !current);
      return !current;
    });
  }, []);

  return { isRail, toggleRail };
}
